jQuery(document).ready(function ($) {
  function experience_carousel() {
    jQuery(".booking-experience-list").slick({
      arrows: true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 9999,
          settings: {
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            arrows: true,
          },
        },
      ],
    });
  }
  function scroll_to_form() {
    jQuery("a[href='#booking-form']").each((i, button) => {
      jQuery(button).on("click", function () {
        jQuery("html, body").animate(
          {
            scrollTop: jQuery("#booking-form").offset().top - 200,
          },
          1000
        );
      });
    });
  }

  let $day_index = "";
  let $day_value = "";
  let $day_text = "";

  let $experience_index = "";
  let $experience_text = "";
  let $experience_value = "";

  let $time_index = "";
  let $time_text = "";
  let $time_value = "";

  function show_date_info() {
    jQuery('select[name="selected_experience"]').on("change", function () {
      $experience_index = jQuery(this).find(":selected").data("index");
      $experience_text = jQuery(this).find(":selected").text().trim();
      $experience_value = jQuery(this).find(":selected").val();

      jQuery(".days select").removeClass("active").hide();
      jQuery(".time-table select").removeClass("active").hide();
      jQuery(".time-table .mask").show();

      $experience_index === "" || $experience_index === undefined
        ? jQuery(`.days .mask`).show()
        : jQuery(
            `.days select[data-index="${$experience_index}"][data-name="${$experience_value}"]`
          )
            .addClass("active")
            .show();

      jQuery("#confirmation-experience").text($experience_text);
    });
  }

  function show_slots_info() {
    jQuery('select[name="selected_day"]').on("change", function () {
      $day_index = jQuery(this).find(":selected").data("index");
      $day_text = jQuery(this).find(":selected").text().trim();
      $day_value = jQuery(this).find(":selected").val();
      $data_name = jQuery(this).data("name");

      jQuery(".time-table select").removeClass("active").hide();
      $day_index === "" || $day_index === undefined
        ? jQuery(`.time-table .mask`).show()
        : jQuery(
            `.time-table select[data-day="${$day_value}"][data-index="${$day_index}"][data-name="${$data_name}"]`
          )
            .addClass("active")
            .show();

      jQuery("#confirmation-day").text($day_text);
    });
  }

  function set_time_info() {
    jQuery('select[name="selected_time"]').on("change", function () {
      $time_index = jQuery(this).find(":selected").data("index");
      $time_text = jQuery(this).find(":selected").text().trim();
      $time_value = jQuery(this).find(":selected").val();

      jQuery("#confirmation-time").text($time_text);
    });
  }

  function show_event_rules() {
    const $rules_content = jQuery(".event-rules-container").html();
    jQuery(".booking-form-field.rules .event-rules-title span").on(
      "click",
      function () {
        jQuery("#modal").addClass("event-rules").fadeIn();
        jQuery("#modal #text-content").html($rules_content);
        jQuery("#modal #modal-close").on("click", () => {
          setTimeout(() => {
            jQuery("#modal").removeClass("event-rules");
          }, 500);
        });
      }
    );
  }

  function show_account_section() {
    jQuery('input[name="form_account"').on("change", function () {
      jQuery(".field-wrapper.account-section").toggleClass("show");
    });
  }

  function show_password() {
    const $password_input = jQuery(".form-field.password input");
    const $password_eye = jQuery("#password-eye");
    jQuery("#password-eye").on("click", function () {
      if ($password_input.attr("type") === "password") {
        $password_input.attr("type", "text");
        $password_eye.addClass("open");
      } else {
        $password_input.attr("type", "password");
        $password_eye.removeClass("open");
      }
    });
  }

  function display_message(data, callback) {
    let $messages = [];
    let $status = "";
    let $data = data ? data : "";
    if ($data.responseText) {
      let $response_text = $data.responseText;
      $response_text = $response_text.replace(/}{/g, "},{");
      $response_text = JSON.parse("[" + $response_text + "]");
      $messages = $response_text.map((obj) => obj.message);
    } else {
      $messages.push(data.message);
      $status = $data.status;
    }
    let $total_messages = $messages.length;
    let $messages_displayed = 0;
    jQuery("#modal").fadeIn();
    jQuery("#modal #tag").text("Aguarde...");
    jQuery("#modal #text-content").html(`<span id="message"></span>`);
    jQuery("#modal #modal-close").on("click", () => callback());
    $messages.forEach(($message, $index) => {
      setTimeout(() => {
        jQuery("#modal #message").slideUp();
        jQuery("#modal #text-content").html(
          `<span id="message">${$message}</span>`
        );
        $messages_displayed++;
        if ($messages_displayed === $total_messages) {
          if ($status === "" || $status === "success" || $status === 200) {
            jQuery("#modal #tag").text("Pronto!").addClass("success");
          } else if ($status === "error") {
            jQuery("#modal #tag").text("Opa...").addClass("error");
          } else {
            jQuery("#modal #tag").text("Opa...").addClass("warning");
          }
        }
      }, 1500 * $index);
    });
  }

  function form_success() {
    var $form_success = jQuery(".booking-form-success").html();
    jQuery("#modal #content-container").html(
      `<div class="booking-form-success active">${$form_success}</div>`
    );
    jQuery("#modal").fadeIn();
    jQuery("#modal #modal-close").on("click", () => location.reload());
  }

  // async function recaptcha() {
  //   // console.log("recaptcha: ", grecaptcha.getResponse());
  //   if (grecaptcha.getResponse() != "") {
  //     const $data = {
  //       action: "recaptcha",
  //       nouncecheck: ajaxScript.nouncecheck,
  //       response: grecaptcha.getResponse(),
  //     };
  //     try {
  //       const $response = await jQuery.ajax({
  //         type: "POST",
  //         url: ajaxScript.ajaxurl,
  //         cache: false,
  //         data: $data,
  //         dataType: "json",
  //       });
  //       let $responseJson = JSON.parse($response);
  //       if ($responseJson["success"] && $responseJson["success"] === true) {
  //         return true;
  //       } else {
  //         display_message(
  //           {
  //             status: "warning",
  //             message: "A validação do recaptcha expirou.",
  //           },
  //           grecaptcha.reset()
  //         );
  //         return false;
  //       }
  //     } catch (error) {
  //       // console.log("error: ", error);
  //       return false;
  //     }
  //   } else {
  //     display_message(
  //       {
  //         status: "warning",
  //         message: "Confirme que você não é um robô.",
  //       },
  //       grecaptcha.reset()
  //     );
  //   }
  // }

  /*
   * Form
   */
  const $form = jQuery("#booking-form");

  $.validator.addMethod(
    "lettersonly",
    function (value) {
      return /^[a-zA-ZÀ-ÖØ-öø-ÿ\s]+$/.test(value);
    },
    "*Este campo só aceita letras."
  );
  $.validator.addMethod(
    "noSpaces",
    function (value, element) {
      return value.trim().length > 0;
    },
    "*O campo está vazio."
  );
  $.validator.addMethod(
    "cpfBR",
    function (value) {
      value = value.replace(/[^\d]/g, "");
      return value.length === 11;
    },
    "Insira um CPF válido."
  );
  $.validator.addMethod(
    "valueNotEquals",
    function (value, element, arg) {
      return arg !== value;
    },
    "Selecione uma opção válida."
  );
  $.validator.addMethod(
    "dateFormat",
    function (value, element) {
      return value.match(/^\d{2}\/\d{2}\/\d{4}$/);
    },
    "*Insira uma data válida no formato dd/mm/aaaa"
  );

  $.validator.addMethod(
    "validateAge",
    function (value, element) {
      const [day, month, year] = value.split("/").map(Number);
      const currentYear = new Date().getFullYear();
      const minYear = 1900;
      const minAge = 18;

      // Valida os limites de dia, mês e ano
      if (
        day < 1 ||
        day > 31 ||
        month < 1 ||
        month > 12 ||
        year < minYear ||
        year > currentYear
      ) {
        return false; // Data fora do intervalo
      }

      // Verifica se a data informada é válida
      const birthDate = new Date(year, month - 1, day);
      if (birthDate > new Date()) return false; // Data no futuro

      // Calcula a idade
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const isBirthdayPassed =
        today.getMonth() > birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
          today.getDate() >= birthDate.getDate());

      // Ajuste para a idade exata considerando o dia e mês
      if (!isBirthdayPassed) {
        age--;
      }

      return age >= minAge;
    },
    "*Você precisa ter pelo menos 18 anos."
  );
  
  const validation = $form.validate({
    rules: {
      selected_day: {
        required: true,
        valueNotEquals: "mask",
      },
      selected_experience: {
        required: true,
        valueNotEquals: "mask",
      },
      selected_time: {
        required: true,
        valueNotEquals: "mask",
      },
      firstname: {
        lettersonly: true,
        noSpaces: true,
        minlength: 2,
        required: true,
      },
      lastname: {
        lettersonly: true,
        noSpaces: true,
        minlength: 2,
        required: true,
      },
      phone: {
        minlength: 15,
        required: true,
      },
      cpf: {
        cpfBR: true,
        required: true,
      },
      birthdate: {
        dateFormat: true,
        required: true,
        validateAge: true,
      },
      state: {
        required: true,
      },
      email: {
        email: true,
        required: true,
      },
      username: {
        required: false,
      },
      password: {
        // minlength: 8,
        required: false,
      },
      form_privacy: {
        required: true,
      },
      form_rules: {
        required: true,
      },
    },
    messages: {
      selected_day: {
        required: "*Selecione um dia.",
        valueNotEquals: "*Selecione um dia.",
      },
      selected_experience: {
        required: "*Selecione uma experiência.",
        valueNotEquals: "*Selecione uma experiência.",
      },
      selected_time: {
        required: "*Selecione um horário.",
        valueNotEquals: "*Selecione um horário.",
      },
      firstname: {
        minlength: "*Informe um nome com ao menos 2 letras.",
        required: "*Informe seu nome.",
        noSpaces: "*O campo está vazio.",
      },
      lastname: {
        minlength: "*Informe um nome com ao menos 2 letras.",
        required: "*Informe seu sobrenome.",
        noSpaces: "*O campo está vazio.",
      },
      phone: {
        minlength: "*Por favor, informe um telefone válido.",
        required: "*Informe seu telefone.",
      },
      cpf: {
        cpfBR: "*Por favor, informe um CPF válido.",
        required: "*Informe seu CPF.",
      },
      birthdate: {
        validateAge: "*Você precisa ter pelo menos 18 anos.",
        dateFormat: "*Insira uma data válida no formato dd/mm/aaaa",
        required: "*Informe sua data de nascimento.",
      },
      state: {
        required: "*Informe seu estado.",
      },
      email: {
        email: "*Por favor, informe um email válido.",
        required: "*Informe seu email.",
      },
      username: {
        required: "*Informe um apelido/nome de usuário.",
      },
      password: {
        minlength: "*A senha precisa ter no mínimo 8 caracteres.",
        required: "*Informe uma senha.",
      },
      form_privacy: {
        required: "*É preciso ler e aceitar a política de privacidade.",
      },
      form_rules: {
        required: "*É preciso ler e aceitar as regras do evento.",
      },
    },
    highlight: function (element, errorClass, validClass) {
      $(element)
        .parents(".form-field")
        .addClass(errorClass)
        .removeClass(validClass);
      $(element)[0].scrollIntoView({ behavior: "smooth", block: "center" });
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents(".error").removeClass(errorClass).addClass(validClass);
    },
  });

  function register_newsletter() {
    let $newsletter = jQuery('input[name="form_newsletter"]:checked');
    let $privacy = jQuery('input[name="form_rules"]:checked');
    let $nome = jQuery('input[name="firstname"]', $form).val();
    let $sobrenome = jQuery('input[name="lastname"]', $form).val();
    let $nome_completo = $nome + " " + $sobrenome;
    let $telefone =
      "+55" + jQuery('input[name="phone"]').val().replace(/\D/g, "");
    let $documento = jQuery('input[name="cpf"]').val().replace(/\D/g, "");
    let $email = jQuery('input[name="email"]').val();
    let $estado = jQuery('select[name="state"]').find(":selected").val();
    let $nascimento = jQuery('input[name="birthdate"]').val();
    $nascimento = $nascimento.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$3/$2/$1");
    let $page_url = window.location.href;

    const formData = new FormData();
    formData.append("action", "ajax_send_newsletter_form");
    formData.append("noncecheck", ajaxScript.nouncecheck);
    formData.append("formtype", $('input[name="formtype"]', $form).val());
    formData.append("name", $nome_completo);
    formData.append("phone", $telefone);
    formData.append("cpf", $documento);
    formData.append("age", $telefone);
    formData.append("state", $estado);
    formData.append("email", $email);
    formData.append("page_url", $page_url);
    formData.append("aceite_promo_newsletter", $newsletter > 0 ? true : false);
    formData.append("aceite_politica_privacidade", $privacy > 0 ? true : false);

    jQuery.ajax({
      type: "POST",
      url: ajaxScript.ajaxurl,
      cache: false,
      contentType: false,
      data: formData,
      dataType: "json",
      processData: false,
      error: function (data) {
        // console.log("error_newsletter: ", data);
      },
      success: function (data) {
        // console.log("error_newsletter: ", data);
      },
    });
  }

  function register_new_user() {
    let $newUser = jQuery('input[name="form_account"]:checked');
    let $newsletter = jQuery('input[name="form_newsletter"]:checked');
    let $privacy = jQuery('input[name="form_rules"]:checked');
    let $nome = jQuery('input[name="firstname"]', $form).val();
    let $sobrenome = jQuery('input[name="lastname"]', $form).val();
    let $telefone = jQuery('input[name="phone"]').val();
    let $documento = jQuery('input[name="cpf"]').val();
    let $email = jQuery('input[name="email"]').val();
    let $estado = jQuery('select[name="state"]').find(":selected").val();
    let $nascimento = jQuery('input[name="birthdate"]').val();
    $nascimento = $nascimento.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$3/$2/$1");
    let $usuario = $('input[name="username"]').val();
    let $senha = $('input[name="password"]').val();

    const formData = new FormData();
    formData.append("action", "send_register_form");
    formData.append("nouncecheck", ajaxScript.nouncecheck);

    formData.append("form_newsletter", $newsletter.length > 0 ? "on" : "off");
    formData.append("form_privacy", $privacy.length > 0 ? "on" : "off");

    formData.append("firstname", $nome);
    formData.append("lastname", $sobrenome);
    formData.append("phone", $telefone);
    formData.append("cpf", $documento);
    formData.append("birthdate", $nascimento);
    formData.append("state", $estado);
    formData.append("email", $email);
    formData.append("username", $usuario);
    formData.append("password", $senha);

    //Realizar validação de campo nome e senha caso checkbox seja clicado. quase error jqueryValidator nos campos

    jQuery.ajax({
      type: "POST",
      url: ajaxScript.ajaxurl,
      cache: false,
      contentType: false,
      data: formData,
      dataType: "json",
      processData: false,
      error: function (data) {
        // console.log("error_user: ", data);
      },
      success: function (data) {
        // console.log("error_user: ", data);
      },
    });
  }

  jQuery('#booking-form input[type="submit"]').on("click", async function (ev) {
    ev.preventDefault();
    let $newUser = jQuery('input[name="form_account"]:checked');

    let elementSubmitButton = $('input[type="submit"]', $form);
    elementSubmitButton.val("Enviando...").attr("disabled", "disabled");

    let $newsletter = jQuery('input[name="form_newsletter"]').is(":checked");
    let $new_account = jQuery('input[name="form_account"]').is(":checked");

    validation.form();
    // console.log("NEW USER:");
    // console.log($newUser);
    // //Validação se esta marcado nova conta, analise campos usuario e senha se passar
    // if ($newUser) {
    //   console.log("New user existente");
    //   let $usuario = $('input[name="username"]').val();
    //   let $senha = $('input[name="password"]').val();

    //   if($usuario !== '' && $usuario !== null & $senha !== '' && $senha !== null){

    //   }
    // }
    if ($newUser.length) {
      // Verificar se os campos estão preenchidos
      let $usuario = $('input[name="username"]').val();
      let $senha = $('input[name="password"]').val();
      let hasError = false;

      // Remover mensagens de erro antigas antes de adicionar novas
      $('input[name="username"]').siblings(".error-message").remove();
      $('input[name="password"]').siblings(".error-message").remove();

      // Validar campo username
      if (!$usuario || $usuario.trim() === "") {
        $('input[name="username"]').addClass("error");
        if (
          $('input[name="username"]').siblings(".error-message").length === 0
        ) {
          $('input[name="username"]').after(
            '<span class="error-message">*Informe um nome de usuário.</span>'
          );
        }
        hasError = true;
      } else {
        $('input[name="username"]').removeClass("error");
      }

      // Validar campo password
      if (!$senha || $senha.trim() === "") {
        $('input[name="password"]').addClass("error");
        if (
          $('input[name="password"]').siblings(".error-message").length === 0
        ) {
          $('input[name="password"]').after(
            '<span class="error-message">*Informe uma senha.</span>'
          );
        }
        hasError = true;
      } else {
        $('input[name="password"]').removeClass("error");
      }

      // Se houver erro, interromper o envio
      if (hasError) {
        elementSubmitButton
          .removeAttr("disabled")
          .val(elementSubmitButton.data("label"));
        return false;
      }
    }

    if (validation.valid()) {
      // const isRecaptchaValid = await recaptcha();

      // if (!isRecaptchaValid) {
      //   elementSubmitButton
      //     .removeAttr("disabled")
      //     .val(elementSubmitButton.data("label"));
      //   return;
      // }

      let $nome =
        jQuery('input[name="firstname"]').val() +
        " " +
        jQuery('input[name="lastname"]').val();
      let $telefone =
        "+55" + jQuery('input[name="phone"]').val().replace(/\D/g, "");
      let $documento = jQuery('input[name="cpf"]').val().replace(/\D/g, "");
      let $email = jQuery('input[name="email"]').val();
      let $estado = jQuery('select[name="state"]').find(":selected").val();
      let $nascimento = jQuery('input[name="birthdate"]')
        .val()
        .replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, "$3-$2-$1");

      let $nome_evento = jQuery('input[name="event_name"]').val();

      let $id_evento = jQuery('select[name="selected_time"].active')
        .find(":selected")
        .data("event");
      let $id_dia = jQuery('select[name="selected_time"].active')
        .find(":selected")
        .data("day");
      let $id_horario = jQuery('select[name="selected_time"].active')
        .find(":selected")
        .data("index");

      let $location = jQuery('.event-banner-info--location').text().trim();

      const formData = new FormData();
      formData.append("action", "event_user_register");
      formData.append("nouncecheck", ajaxScript.nouncecheck);
      formData.append("nome", $nome);
      formData.append("telefone", $telefone);
      formData.append("documento", $documento);
      formData.append("email", $email);
      formData.append("nascimento", $nascimento);
      formData.append("estado", $estado);

      formData.append("id_evento", $id_evento);
      formData.append("id_dia", $id_dia);
      formData.append("id_hora", $id_horario);

      formData.append("nome_do_evento", $nome_evento);
      formData.append("nome_da_experiencia", $experience_text);
      formData.append("data", $day_text);
      formData.append("hora", $time_text);
      formData.append("local", $location);

      jQuery.ajax({
        type: "POST",
        url: ajaxScript.ajaxurl,
        cache: false,
        contentType: false,
        data: formData,
        dataType: "json",
        processData: false,
        error: function (data) {
          console.log("error: ", data);
          elementSubmitButton
            .removeAttr("disabled")
            .val(elementSubmitButton.data("label"));
          if (
            data.status === "success" ||
            data.status === 200 ||
            data.responseText !== "0"
          ) {
            display_message(data, form_success);
          } else {
            display_message(
              {
                status: "error",
                message:
                  "Ocorreu um erro no envio dos seus dados. Por favor, tente novamente em alguns instantes.",
              },
              () => {}
            );
          }
        },
        success: function (data) {
          console.log("success: ", data);
          elementSubmitButton
            .removeAttr("disabled")
            .val(elementSubmitButton.data("label"));
          if (data.status === "success") {
            display_message(data, form_success);
          } else {
            display_message(
              {
                status: "error",
                message: data.message,
              },
              () => {}
            );
          }
        },
      });

      if ($newsletter) {
        register_newsletter();
      }

      if ($new_account) {
        register_new_user();
      }
    } else {
      elementSubmitButton
        .removeAttr("disabled")
        .val(elementSubmitButton.data("label"));
    }
  });

  function updateNonce() {
    jQuery.ajax({
      url: ajaxScript.ajaxurl,
      method: "POST",
      data: {
        action: "get_new_nonce",
      },
      success: function (response) {
        if (response.success) {
          ajaxScript.nouncecheck = response.data.nonce;
          // console.log("Nonce atualizado:", ajaxScript.nouncecheck);
        } else {
          console.error("Erro ao atualizar o nonce.");
        }
      },
      error: function () {
        console.error("Erro na renovação do nonce.");
      },
    });
  }

  jQuery(window).on("load", function () {
    updateNonce();
  });

  experience_carousel();
  scroll_to_form();
  show_date_info();
  show_slots_info();
  set_time_info();
  show_event_rules();
  show_account_section();
  show_password();
});
